import React, { useState } from 'react';
import { Button, Card, CardBody, Col, Container, Form, FormFeedback, FormGroup, Input, Label, Row, Spinner } from 'reactstrap';
import { formatarValorReal, formatCNPJ } from '../../uteis/uteis';
import * as yup from "yup";
import { Formik } from 'formik';
import { getDados } from '../../services/consulta';
import { toast } from 'react-toastify';

const schema = yup.object().shape({
    cnpj: yup
        .string()
        .required("É necessário preencher o campo CNPJ.")
        .test("no-spaces", "É necessário preencher o campo CNPJ.", (value) => value?.trim().length > 0)

});
const Consulta = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [empresa, setEmpresa] = useState(null);

    const handleBuscarDados = async (value) => {
        setIsLoading(true);
        await getDados(value.cnpj)
            .then((data) => {
                if (data === null) {
                    toast.info("Nenhum dado foi localizado para o CNPJ informado.");
                    setEmpresa(null);
                }
                setEmpresa(data);
            })
            .catch((e) => {
                console.log(e);
                toast.info("Erro ao buscar dados da empresa.");
            })
            .finally(() => { setIsLoading(false); });
    }

    return (
        <>
            <Container id='conteudo-analise-risco' className="mt--7 p-4" fluid>
                <Col lg="12" md="12">
                    <Formik
                        validationSchema={schema}
                        onSubmit={async (values) => {
                            handleBuscarDados(values);
                        }}
                        initialValues={{ cnpj: '' }}
                        validateOnChange={false}
                        validateOnBlur={false}
                    >
                        {({ handleSubmit, handleChange, values, errors }) => (
                            <Card className="shadow border-0 rounded-lg">
                                <CardBody className="px-lg-4 py-lg-4">
                                    <Form role="form" onSubmit={handleSubmit}>
                                        <p className="mb-4 text-color">Consultas</p>
                                        <Row>
                                            <Col lg={4}>
                                                <FormGroup floating>
                                                    <Input
                                                        id='cnpj'
                                                        name="cnpj"
                                                        maxLength={18}
                                                        placeholder="CNPJ"
                                                        value={formatCNPJ(values.cnpj)}
                                                        invalid={!!errors.cnpj}
                                                        disabled={isLoading}
                                                        onChange={handleChange}
                                                    />
                                                    <Label for="cnpj">CNPJ</Label>
                                                    <FormFeedback>{errors.cnpj}</FormFeedback>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <div className="text-center">
                                            <Button
                                                className="my-4 px-6"
                                                color="primary"
                                                type="submit"
                                                disabled={isLoading}
                                            >
                                                {isLoading ? <Spinner size="sm" /> : "Consultar"}
                                            </Button>
                                        </div>
                                    </Form>
                                </CardBody>
                            </Card>
                        )}
                    </Formik>
                    {empresa && (
                        <Card className="mt-4 shadow-sm border-0 p-3">
                            <CardBody>
                                <h4 className="mb-4">{empresa.nome_fantasia || empresa.razao_social}</h4>

                                <h5 className="mb-2">Identificação</h5>
                                <Row className="mb-3">
                                    <Col md={6}><strong>CNPJ:</strong> {empresa.cnpj_completo}</Col>
                                    <Col md={6}><strong>Razão Social:</strong> {empresa.razao_social}</Col>
                                    <Col md={6}><strong>Nome Fantasia:</strong> {empresa.nome_fantasia || '—'}</Col>
                                    <Col md={6}><strong>Matriz/Filial:</strong> {empresa.identificador_matriz_filial}</Col>
                                    <Col md={6}><strong>Data de Início:</strong> {new Date(
                                        empresa.data_incio_atividade.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3")
                                    ).toLocaleDateString()}</Col>
                                </Row>

                                <h5 className="mb-2">Dados Societários</h5>
                                <Row className="mb-3">
                                    <Col md={6}><strong>Capital Social:</strong> R$ {formatarValorReal(empresa.capital_social)}</Col>
                                    <Col md={6}><strong>Porte:</strong> {empresa.porte_empresa}</Col>
                                    <Col md={6}><strong>Natureza Jurídica:</strong> {empresa.natureza_juridica}</Col>
                                    <Col md={6}><strong>Qualificação:</strong> {empresa.qualificacao}</Col>
                                </Row>

                                <h5 className="mb-2">Atividade Econômica</h5>
                                <Row className="mb-3">
                                    <Col md={12}><strong>Principal:</strong> {empresa.cnae_fiscal_principal}</Col>
                                    <Col md={12}><strong>Secundária:</strong> {empresa.cnae_fiscal_secundaria || '—'}</Col>
                                </Row>

                                <h5 className="mb-2">Endereço</h5>
                                <Row className="mb-3">
                                    <Col md={6}><strong>Tipo de Logradouro:</strong> {empresa.tipo_logradouro}</Col>
                                    <Col md={6}><strong>Logradouro:</strong> {empresa.logradouro}, {empresa.numero}</Col>
                                    <Col md={6}><strong>Complemento:</strong> {empresa.complemento || '—'}</Col>
                                    <Col md={6}><strong>Bairro:</strong> {empresa.bairro}</Col>
                                    <Col md={6}><strong>CEP:</strong> {empresa.cep}</Col>
                                    <Col md={6}><strong>Município:</strong> {empresa.municipio} - {empresa.uf}</Col>
                                </Row>

                                <h5 className="mb-2">Sócio / Representante</h5>
                                <Row>
                                    <Col md={6}><strong>Nome:</strong> {empresa.nome_socio_razao_social}</Col>
                                    <Col md={6}><strong>Qualificação:</strong> {empresa.qualificacao_socio}</Col>
                                    <Col md={6}><strong>CPF/CNPJ:</strong> {empresa.cpf_cnpj_socio}</Col>
                                </Row>
                            </CardBody>
                        </Card>
                    )}

                </Col>
            </Container >
        </>
    );
};

export default Consulta;